<template>
  <v-window class="minHeight mb-5">
    <parking-common :parking="parking" :isParkingDetail="true">
      <!-- <user-non-available v-if="userNonAvailable"></user-non-available> -->

      <parking-non-available
        v-if="parkingNonAvailable && isLogged"
        :parking="parking"
      ></parking-non-available>

      <booking-create-wrapper
        v-else-if="isLogged"
        :tab-param="tab"
        :parking="parking"
      ></booking-create-wrapper>

      <parking-pricing v-else :parking="parking"></parking-pricing>

      <!-- <template v-if="showPaymentSubscriptionRetry">
        <div style="visibility: hidden">
          <payment-internal
            :subscription="subscription"
            :parking="parking"
            :open-automatically="openAutomatically"
          ></payment-internal>
        </div>
      </template> -->
    </parking-common>
  </v-window>
</template>

<script>
import store from '@/store';
import parkingService from '@/services/parkingService';
import paymentService from '@/services/paymentService';
import ParkingCommon from '@/components/commons/ParkingCommon';
import ParkingPricing from '@/components/public/ParkingPricing';
import ParkingNonAvailable from '@/components/private/ParkingNonAvailable';
import UserNonAvailable from '@/components/private/UserNonAvailable';
import BookingCreateWrapper from '@/components/private/booking/BookingCreateWrapper';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import utilService from '@/services/utilService';
import PaymentInternal from '@/components/commons/PaymentInternal';

export default {
  name: 'ParkingDetail',
  props: {
    alias: {
      type: String,
      required: true,
    },
  },
  components: {
    [ParkingCommon.name]: ParkingCommon,
    [ParkingPricing.name]: ParkingPricing,
    [ParkingNonAvailable.name]: ParkingNonAvailable,
    [UserNonAvailable.name]: UserNonAvailable,
    [BookingCreateWrapper.name]: BookingCreateWrapper,
    [PaymentInternal.name]: PaymentInternal,
  },
  computed: {
    isLogged() {
      return store.state.isLogged;
    },
    parkingNonAvailable() {
      return !parkingService.isActivedParking(this.parking);
    },
    parkingDescription() {
      if (typeof this.parking.description !== 'undefined') {
        return this.parking.description.description.text;
      } else {
        return this.parking.address;
      }
    },
    parkingInstructions() {
      if (typeof this.parking.instructions !== 'undefined') {
        return this.parking.instructions;
      } else {
        return this.parking.address;
      }
    },
    twitterHashtag() {
      return store.state.countrySelected.twitterHashtag;
    },
    sharedImage() {
      return utilService.getSharedImage(this.parking.image);
    },
  },
  metaInfo() {
    return {
      title: this.$i18n.t('page.title'),
      meta: [
        {
          name: 'description',
          content: this.parking.name,
        },
        {
          name: 'apple-itunes-app',
          content: 'app-id=573568924',
        },
        {
          name: 'keywords',
          content: this.$i18n.t('page.keywords'),
        },
        {
          property: 'twitter:title',
          content: this.parking.name,
        },
        {
          property: 'twitter:card',
          content: 'photo',
        },
        {
          property: 'twitter:site',
          content: this.twitterHashtag,
        },
        {
          property: 'twitter:image',
          content: this.sharedImage,
        },
        {
          property: 'twitter:url',
          content: window.location.href,
        },
        {
          property: 'og:title',
          content: this.parking.name,
        },
        {
          property: 'og:url',
          content: window.location.href,
        },
        {
          property: 'og:site_name',
          content: 'wesmartPark',
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:description',
          content: this.parkingDescription,
        },
        {
          property: 'og:description',
          content: this.parkingInstructions,
        },
        {
          property: 'og:image',
          content: this.sharedImage,
        },
        {
          property: 'og:image:secure_url',
          content: this.sharedImage,
        },
        {
          property: 'og:image:alt',
          content: this.parking.name,
        },
        {
          property: 'og:image:width',
          content: '600',
        },
        {
          property: 'og:image:height',
          content: '450',
        },
        {
          property: 'og:image:type',
          content: 'image/jpeg',
        },
      ],
    };
  },
  data() {
    return {
      parking: {},
      tab: 0,
      showPaymentSubscriptionRetry: false,
      openAutomatically: false,
      subscription: {},
    };
  },

  async mounted() {
    if (typeof this.$route.query.ok !== 'undefined') {
      let message = 'global.buy.error';
      let type = 'error';
      let doNotTranslate = false;
      if (this.$route.query.ok.indexOf('OK') >= 0) {
        message = 'global.buy.plan.success';
        type = 'success';
        this.tab = 1;
        this.$mam.actionBuy();
      } else {
        let errorMessageData = await paymentService.getErrorCause(
          this.$route.query.paymentId
        );
        message = `<strong>${
          errorMessageData.data.message
        }.</strong> <br/> ${this.$i18n.t('global.buy.error')}.`;
        doNotTranslate = true;

        let responseShouldRetry = await paymentService.getShouldRetry(
          this.$route.query.paymentId
        );
        if (
          !responseShouldRetry.error &&
          responseShouldRetry.data.shouldRetry
        ) {
          this.subscription = store.state.lastSubscription;
          this.openAutomatically = true;
          this.showPaymentSubscriptionRetry = true;
        }
      }

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: message,
        type: type,
        doNotTranslate: doNotTranslate,
        isHtml: true,
      });
    }
  },
  created() {
    this.loadParking();
    EventBus.$on(keys.eventOnLanguageChanged, this.changeLanguage);
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.changeLanguage);
  },
  methods: {
    changeLanguage() {
      this.loadParking();
    },
    async loadParking() {
      let params = {
        alias: this.alias,
      };

      let resp = await parkingService.getParking(params);
      if (resp.error) {
        if (resp.status === 404) {
          this.$router.push({ name: 'NotFound' });
        }
      } else {
        this.parking = resp.data;
        store.commit('CHANGE_TITLE_SECTION', { text: this.parking.name });
      }
    },
  },
};
</script>

<style lang="scss">
.parkingDetail .v-responsive.v-image.v-carousel__item {
  height: 250px !important;
}
</style>
